import Vue from 'vue';
import {
    mapGetters, mapState,
} from 'vuex';
import _ from 'lodash';
import {
    Menu,
    Submenu,
    MenuItem,
} from 'element-ui';

import { getB2BUrl } from '../../http/helpers';

Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);

export default {
    name: 'sideMenu',
    data() {
        return {
            activeIndex: '',
            opensArr: [],
            copyOpArr: [],
            hoverClass: 'has-hover',
            hasHover: [],
        };
    },
    watch: {
        $route: {
            deep: true,
            handler(val) {
                if (val.name === 'orderEdit') { // 再来一单刷新左侧导航
                    this.opensArr = [`${1}`, `${1}-${0}`];
                } else {
                    this.handleSelect(this.opensArr[0]);
                }
                this.rangeMenuArr(val.path);
            }
        },
    },
    computed: {
        ...mapGetters({
            sideMenu: 'getSideMenu',
        }),
        ...mapState({
            authList: ({ appInfo }) => appInfo.authList,
            loginType: ({ appInfo }) => appInfo.loginType,
        })
    },
    created() {
        // this.rangeMenuArr(this.$route.path);
    },
    mounted() {
        this.rangeMenuArr(this.$route.path);
    },
    methods: {
        addHover(id) {
            this.hasHover.push(id);
        },
        removeHover() {
            this.hasHover.shift();
        },
        handleSelect(index) {
            this.activeIndex = index;
        },
        goUrl(path) {
            this.$router.push({
                path
            });
        },
        goB2B() {
            window.open(getB2BUrl(), '_blank');
        },
        rangeMenuArr(pathStr) {
            _.each(this.sideMenu, (item, i) => {
                _.each(item.list, (subItem, subI) => {
                    if (subItem.path === pathStr) {
                        this.opensArr = [`${i}`, `${i}-${subI}`];
                        this.copyOpArr = [`${i}`, `${i}-${subI}`];
                        this.activeIndex = String(i);
                    }
                });
            });
        },
        closeArrEv() {
            this.opensArr = [];
        },
        opensArrEv(e) {
            if (e === this.copyOpArr[0]) {
                this.rangeMenuArr(this.$route.path);
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/components/SideMenu/sideMenu.js